import React, { useEffect, useState } from 'react';

import { Container, Content, TitleDate, InfoCard, Button, ButtonSwitch } from "./styles"

import { useAuth } from '../../contexts/AuthContexts';
import { db } from '../../firebase';
import { getDoc, doc, setDoc } from "firebase/firestore";


import { useNavigate } from "react-router-dom";

export const Special = () => {

    const [ trainCheck, setTrainCheck ] = useState([false,false,false,false,false,false,false]);
    const [ dietCheck, setDietCheck ] = useState([false,false,false,false,false,false,false]);
    const week = ["seg", "ter", "quar", "qui", "sex", "sab", "dom"]
    const [ loading, setLoading ] = useState(false);
    const [ error, setError ] = useState("");
    
    
    const { currentUser } = useAuth();
    const history = useNavigate();

    const handleTrack = async () => {
        if(!currentUser || !currentUser.uid) return;

        setLoading(true);

        try{
            const userSnap = await getDoc(doc(db, "users", currentUser.uid));

            if(userSnap.exists()){
                const userData = userSnap.data();
                const nDietDays = userData.dietDaysCount;
                const nTrainingDays = userData.trainingDaysCount;

                let currentDate = new Date();
                currentDate.setDate(currentDate.getDate() - 7);
                console.log("look:", currentDate)
                const currentWeek = new Date(currentDate.setDate(currentDate.getDate() - (currentDate.getDay() + 6)%7));
                
                let dietDaysList = {};
                let trainingDaysList = {};
                let nDietCount = nDietDays;
                let nTrainingCount = nTrainingDays;

                const date = currentWeek;
                for(let i = 0; i < 7; i++){
                    const isoDate = String(date.getFullYear() + "-" + String(parseInt(date.getMonth() + 1)).padStart(2, '0') + "-" + String(date.getDate()).padStart(2, '0'));
                    dietDaysList[isoDate] = dietCheck[i];
                    trainingDaysList[isoDate] = trainCheck[i];
                    nDietCount += (userData.dietDaysMap[isoDate] || false) !== dietCheck[i] ? (dietCheck[i] ? 1 : -1) : 0;
                    nTrainingCount += (userData.trainingDaysMap[isoDate] || false) !== trainCheck[i] ? (trainCheck[i] ? 1 : -1) : 0;
                    date.setDate(date.getDate() + 1);
                }


                await setDoc(doc(db, "users", currentUser.uid), {
                    dietDaysMap: dietDaysList,
                    dietDaysCount: nDietCount,
                }, {merge: true});
                
                await setDoc(doc(db, "users", currentUser.uid), {
                    trainingDaysMap: trainingDaysList,
                    trainingDaysCount: nTrainingCount,
                }, {merge: true});
            }
            history("/home");
        } catch(e) {
            console.log(e);
            setError("Failed to Track");
        }
        setLoading(false);
    };

    const getInfoFromDb = async () => {
        if(!currentUser || !currentUser.uid) return;

        const userSnap = await getDoc(doc(db, "users", currentUser.uid));


        let currentDate = new Date();
        currentDate.setDate(currentDate.getDate() - 7);
        const currentWeek = new Date(currentDate.setDate(currentDate.getDate() - (currentDate.getDay() + 6)%7));

        let dietMap = []
        let trainingMap = []

        if(userSnap.exists()){
            const userData = userSnap.data();
            const date = currentWeek;
            for(let i = 0; i < 7; i++){
                const isoDate = String(date.getFullYear() + "-" + String(parseInt(date.getMonth() + 1)).padStart(2, '0') + "-" + String(date.getDate()).padStart(2, '0'));
                dietMap.push(userData.dietDaysMap[isoDate] || false);
                trainingMap.push(userData.trainingDaysMap[isoDate] || false);
                date.setDate(date.getDate() + 1);
            }
            setTrainCheck([...trainingMap]);
            setDietCheck([...dietMap]);
        }else{
            console.log("Erro na consulta ao bd")
        }
    };

    const handleSwitch = (idx, state) => {
        let marked = state;
        marked[idx] = !marked[idx];
        console.log(marked)
        console.log(state)
        console.log()
        return marked
    }

    useEffect(() => {
        getInfoFromDb();
    }, [])

    return(
        <Container>
            <Content>
                <TitleDate>Página especial da semana passada (14/02 - 20/02)</TitleDate>
                <div className='catezgory'>Treino</div>
                <InfoCard>
                    {trainCheck && trainCheck.map((check, idx) => (
                        <ButtonSwitch
                            key={idx}
                            style={{"backgroundColor": check ? "#34C759" : "#1e1e1e", "color": "white" }}
                            onClick={() => setTrainCheck([...handleSwitch(idx, trainCheck)])}
                        >{week[idx]}</ButtonSwitch>
                    ))}
                    
                </InfoCard>
                <div className='category'>Dieta</div>
                <InfoCard>
                    {dietCheck && dietCheck.map((check, idx) => (
                        <ButtonSwitch
                            key={idx}
                            style={{"backgroundColor": check ? "#34C759" : "#1e1e1e", "color": "white" }}
                            onClick={() => setDietCheck([...handleSwitch(idx, dietCheck)])}
                        >{week[idx]}</ButtonSwitch>
                    ))}
                    
                </InfoCard>
                {error}
                <Button disabled={loading} onClick={ handleTrack }> Confirmar </Button>
            </Content>
        </Container>
    );
};
